// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__zoqyA","title":"InfoRow_title__23nh2"};